export default __webpack_public_path__ + "static/media/mfDetailbg.0b12a535.svg";